import React from 'react';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import FormFields from '../FormFields';
import { IsObjectEmpty, IsListEmpty, IsStringEmpty, htmlToText, Log, GetObjectClone } from '../../../utilities/CommonMethods';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import AddIcon from "../../../assets/icons/icon-add-blue.svg";

import classes from './QuizQuestionForm.module.css';
import QuizOption from '../../UI/QuizOption/QuizOption';
import ConfirmationDialog from '../../Popups/ConfirmationDialog/ConfirmationDialog';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';

import ResourceAPIController from '../../../webServices/ResourceAPIController';

class QuizQuestionForm extends React.Component {

    state = {
        newProblemFormData: GetObjectClone(FormFields.newQuizProblemFormData),
        newProblemFormValid: false,
        optionsList: [
            { optionData: 'Option 1', id: '', value: '', type: "text", selected: false, errorMessage: '', valid: true, file: '', imgUrl: '' }
        ],
        questionType: 'single',
        showError: false,
        errorMessage: '',

        showDialogLoader: false,
        showConfirmationDialog: false,
        confirmationDialogMessage: 'Are you sure you want to delete this ',
        confirmationPrimaryButtonLabel: 'DELETE',
        confirmationSecondaryButtonLabel: 'CANCEL',
        optionIndex: null

    }

    checkRemainingCount = (value, inputIdentifier) => {
        var maxLength = this.state.newProblemFormData[inputIdentifier].totalChar;
        var remainingCount = maxLength - value.length;
        return (remainingCount);
    }

    checkValidity = (formElement) => {
        let isValid = true;

        if (!IsObjectEmpty(formElement.validation)) {
            let value = formElement.value;
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value.length > 0) {
                    isValid = true && isValid;
                } else if ((typeof (value) === 'number' && parseInt(value, 10)) || value === 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }

            if (!IsObjectEmpty(rules.isDropdown) && rules.isDropdown.value) {
                isValid = (value >= 0) && isValid;
                formElement.errorMessage = isValid ? '' : rules.isDropdown.errorMessage;
                formElement.valid = isValid;
            }
        }
        return (formElement);
    }

    inputChangedHandlerText = (event, inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];
        if (inputIdentifier === 'questionDescription') {
            updatedFormElement.remainingChar = this.checkRemainingCount(event.target.value, inputIdentifier);

            if (updatedFormElement.remainingChar <= 0) {
                updatedFormElement.value = event.target.value.substring(0, updatedFormElement.totalChar);
                updatedFormElement.remainingChar = 0;
            } else {
                updatedFormElement.value = event.target.value;
            }
        } else {
            updatedFormElement.value = event.target.value;
        }
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }
        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    inputChangedHandlerMarkdown = (value, inputIdentifier) => {
        // console.log('Markdown handler called => ', value);
        value = value === '<p><br></p>' ? '' : value;
        // const plainTextValue = htmlToText(value);

        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];
        // if (inputIdentifier === 'questionDescription') {
        //     updatedFormElement.remainingChar = this.checkRemainingCount(plainTextValue, inputIdentifier)
        //     if (updatedFormElement.remainingChar <= 0) {
        //         // updatedFormElement.value = value.substring(0, updatedFormElement.totalChar);
        //         updatedFormElement.remainingChar = 0;
        //     } else {
        //     }
        // }

        updatedFormElement.value = value;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    onDropDownClick = (inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        const updatedFormElement = updatedForm[inputIdentifier];
        const updatedState = updatedFormElement.dropdownOpen ? false : true;

        for (let item in updatedForm) {
            updatedForm[item].dropdownOpen = false;
        }

        updatedFormElement.dropdownOpen = updatedState;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid });
    }

    onDropDownItemClick = (pos, inputIdentifier) => {
        const updatedForm = this.state.newProblemFormData;
        let updatedFormElement = updatedForm[inputIdentifier];

        updatedFormElement.value = pos;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.dropdownOpen = false;
        updatedForm[inputIdentifier] = updatedFormElement;

        if (inputIdentifier === 'numberOfCorrectAnswers') {
            const dropdownOptons = updatedFormElement.options;
            const updatedQuestionType = dropdownOptons[pos].value;

            let updatedOptionsList = [...this.state.optionsList];

            for (let i = 0; i < this.state.optionsList.length; i++) {
                updatedOptionsList[i].selected = false;
            }
            this.setState({ questionType: updatedQuestionType, optionsList: updatedOptionsList });
        }

        this.setState({ newQuizProblemFormData: updatedForm });
    }

    onOptionClicked = (optionPos, questionType) => {
        let updatedOptionsList = [...this.state.optionsList];

        if (questionType === 'single') {
            for (var i = 0; i < updatedOptionsList.length; i++) {
                if (i === optionPos) {
                    updatedOptionsList[optionPos].selected = true;
                } else {
                    updatedOptionsList[i].selected = false;
                }
            }
        } else {
            let updatedStatus = updatedOptionsList[optionPos].selected;
            updatedOptionsList[optionPos].selected = !updatedStatus;
        }
        this.setState({ optionsList: [...updatedOptionsList], showError: false, errorMessage: '' })
    }

    onOptionInputChanged = (event, index) => {
        let updatedOptionsList = [...this.state.optionsList];
        let updatedValue = event.target.value;

        let inputValid = true;
        let errorMessage = '';

        if (updatedValue.length === 0 && index === 0) {
            errorMessage = "This is a required field"
            inputValid = false;
        } else {
            errorMessage = '';
            inputValid = true;
        }
        updatedOptionsList[index].value = event.target.value;
        updatedOptionsList[index].valid = inputValid;
        updatedOptionsList[index].errorMessage = errorMessage;

        this.setState({ optionsList: updatedOptionsList });
    }

    onAddNewOptionClicked = () => {
        let updatedOptionsList = [...this.state.optionsList];

        updatedOptionsList.push({ optionData: 'Option 1', id: '', value: '', type: "text", selected: false, errorMessage: '', valid: true, file: '', imgUrl: '' });

        this.setState({ optionsList: updatedOptionsList });
    }

    showConfirmationDialog = (index) => {
        const message = `Are you sure you want to delete this option ?`;
        this.setState({ showConfirmationDialog: true, confirmationDialogMessage: message, optionIndex: index });
    }

    onConfirmationPrimaryButtonClicked = () => {
        let pos = this.state.optionIndex;
        let updatedOptionsList = [...this.state.optionsList];
        console.log(pos);
        if (!IsStringEmpty(updatedOptionsList[pos].id)) {
            this.deleteQuizProblemOption(updatedOptionsList[pos].id, pos);
        } else {
            updatedOptionsList.splice(pos, 1);
            this.setState({ optionsList: updatedOptionsList, showConfirmationDialog: false });
        }
    }

    onConfirmationSecondaryButtonClick = () => {
        this.setState({ showConfirmationDialog: false });
    }

    deleteQuizProblemOption = (optionId, pos) => {
        this.setState({ showDialogLoader: true });
        ResourceAPIController.deleteQuizProblemOption(optionId)
            .then(response => {
                Log('Delete option Data => ', response.result);
                let updatedOptionsList = [...this.state.optionsList];
                updatedOptionsList.splice(pos, 1);
                this.setState({ optionsList: updatedOptionsList, showConfirmationDialog: false, showDialogLoader: false });
            })
            .catch(err => {
                console.log('Delete option error => ', err)
                this.setState({ showConfirmationDialog: false, showDialogLoader: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    onOptionImageSelected = (pos, event) => {
        // Log('Inside_Thumbnail_Selected_Function', event.target.files)
        const file = event.target.files[0];
        let imageUrl = '', updatedOptionsList = [...this.state.optionsList];

        if (file !== undefined && file !== null) {
            imageUrl = URL.createObjectURL(file);
            updatedOptionsList[pos].value = event.target.files[0];

            updatedOptionsList[pos].imgUrl = imageUrl;
            updatedOptionsList[pos].type = 'image';
            // console.log('File Option Before Saving => ', event.target.files[0]);


            this.setState({ optionsList: updatedOptionsList });
        } else {
            imageUrl = '';
            Log('No File Data Found');
        }
    }

    onOptionTextSelected = (pos) => {
        let updatedOptionsList = [...this.state.optionsList]
        updatedOptionsList[pos].value = ""
        updatedOptionsList[pos].imgUrl = ""
        updatedOptionsList[pos].type = "text"
        this.setState({ optionsList: updatedOptionsList })
    }

    onFormButtonClicked = () => {
        const updatedForm = this.state.newProblemFormData;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        let updatedOptionsList = [...this.state.optionsList], optionSelected = false;
        for (var i = 0; i < updatedOptionsList.length; i++) {
            optionSelected = optionSelected || updatedOptionsList[i].selected;
        }

        if (optionSelected === false) {
            if (updatedOptionsList[0].type === 'text' && updatedOptionsList[0].value === '') {
                updatedOptionsList[0].valid = false;
                updatedOptionsList[0].errorMessage = "This is a required field"
                formIsValid = false;
            } else {
                this.setState({
                    showError: true,
                    errorMessage: 'Please select at least one correct option'
                })
            }
        } else if (optionSelected === true) {
            if (updatedOptionsList[0].type === 'text' && updatedOptionsList[0].value === '') {
                updatedOptionsList[0].valid = false;
                updatedOptionsList[0].errorMessage = "This is a required field"
                formIsValid = false;
            }
        }

        this.setState({ newProblemFormData: updatedForm, newProblemFormValid: formIsValid && optionSelected });

        if (formIsValid && optionSelected) {

            let updatedOptionsList = [...this.state.optionsList], quizOptionSelector = {};
            let newProblemData = new FormData();
            for (var i = 0; i < updatedOptionsList.length; i++) {
                if (updatedOptionsList[i].type === 'text') {
                    if (this.props.forEdit) {
                        newProblemData.append(`option_${i + 1}`, [updatedOptionsList[i].id, "text", updatedOptionsList[i].selected]);
                    } else {
                        newProblemData.append(`option_${i + 1}`, ["text", updatedOptionsList[i].selected]);
                    }
                    newProblemData.append(`option_${i + 1}_value`, updatedOptionsList[i].value);
                } else {
                    if (this.props.forEdit) {
                        newProblemData.append(`option_${i + 1}`, [updatedOptionsList[i].id, "file", updatedOptionsList[i].selected]);
                    } else {
                        newProblemData.append(`option_${i + 1}`, ["file", updatedOptionsList[i].selected]);
                    }
                    newProblemData.append(`option_${i + 1}_value`, updatedOptionsList[i].value);
                }
            }

            let difficultyLevelOptions = this.state.newProblemFormData.difficultyLevel.options,
                difficultyLevel = this.state.newProblemFormData.difficultyLevel.value,
                difficultyLevelValue = difficultyLevelOptions[difficultyLevel].value;

            newProblemData.append("description", this.state.newProblemFormData.questionDescription.value);
            newProblemData.append("total_points", this.state.newProblemFormData.maxScore.value);
            newProblemData.append("difficulty_level", difficultyLevelValue);
            newProblemData.append("option_count", this.state.optionsList.length);



            // console.log("Final Object => ", quizOptionSelector);
            if (this.props.forEdit) {
                this.props.editQuizQuesitonClicked(this.props.data.id, newProblemData, this.props.pos);
            } else {
                this.props.addNewQuizQuesitonClicked(newProblemData);
            }
        }
    }

    setFormData = () => {
        const problemData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (!IsObjectEmpty(problemData) && this.props.forEdit === true) {
            // alert('Setting UP Initial Data');

            let difficultyLevel = -1, maxScore = '', numberOfCorrectAnswers = 0, questionDescription = '', optionsList = [];

            difficultyLevel = !IsStringEmpty(problemData.level)
                ? problemData.level === 'easy' ? 0
                    : problemData.level === 'medium' ? 1
                        : problemData.level === 'hard' ? 2
                            : 0 : 0;

            maxScore = !IsStringEmpty(problemData.maxScore) ? problemData.maxScore : 0;
            numberOfCorrectAnswers = problemData.type === 'single' ? 0 : problemData.type === 'multiple' ? 1 : 0;
            questionDescription = !IsStringEmpty(problemData.problem) ? problemData.problem : '';
            optionsList = !IsListEmpty(problemData.options) ? problemData.options.map((option) => {
                return ({
                    optionData: '',
                    id: option.id,
                    value: option.option,
                    type: option.type,
                    selected: option.isCorrect,
                    errorMessage: '', valid: true, file: '', imgUrl: ''
                });
            }) : [];

            let updatedFormData = { ...this.state.newProblemFormData };
            updatedFormData['difficultyLevel'].value = difficultyLevel;
            updatedFormData['maxScore'].value = maxScore;
            updatedFormData['numberOfCorrectAnswers'].value = numberOfCorrectAnswers;
            updatedFormData['questionDescription'].value = questionDescription;

            this.setState({ newProblemFormData: updatedFormData, optionsList: optionsList });


        } else {
            // alert('Adding a new Problem');
        }
    }

    componentDidMount() {
        this.setFormData();
    }

    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.newProblemFormData[key].elementType}
            elementConfig={this.state.newProblemFormData[key].elementConfig}
            label={this.state.newProblemFormData[key].label}
            value={this.state.newProblemFormData[key].value}
            options={this.state.newProblemFormData[key].options}
            changed={key === 'questionDescription' ? (value) => this.inputChangedHandlerMarkdown(value, key) : (event) => this.inputChangedHandlerText(event, key)}
            touched={this.state.newProblemFormData[key].touched}
            afterText={this.state.newProblemFormData[key].remainingChar}
            dropdownOpen={this.state.newProblemFormData[key].dropdownOpen}
            onDropDownClick={() => this.onDropDownClick(key)}
            onDropDownItemClick={this.onDropDownItemClick}
            required={!IsObjectEmpty(this.state.newProblemFormData[key].validation) ? (!IsObjectEmpty(this.state.newProblemFormData[key].validation.required) ? this.state.newProblemFormData[key].validation.required.value : false) : false}
            showError={(!this.state.newProblemFormValid && !this.state.newProblemFormData[key].valid) ? true : false}
            error={this.state.newProblemFormData[key].errorMessage}
            showImageOption={true} />
    }

    render() {



        const renderOptionsList = !IsListEmpty(this.state.optionsList) ? this.state.optionsList.map((option, index) => {
            return (
                <QuizOption
                    key={index}
                    forQuizForm={true}
                    pos={index}
                    selected={option.selected}
                    optionType={option.type}
                    questionType={this.state.questionType}
                    name={null}
                    value={option.value}
                    errorMessage={option.errorMessage}
                    imgUrl={option.imgUrl}
                    onOptionClicked={this.onOptionClicked}
                    onInputChanged={this.onOptionInputChanged}
                    onImageFileSelected={this.onOptionImageSelected}
                    onOptionTextSelected={this.onOptionTextSelected}
                    removeOptionClick={(event) => this.showConfirmationDialog(event, index)}
                    optionsListLength={this.state.optionsList.length}
                />
            );
        }) : null;

        return (

            <div className={classes.Form}>

                <h4 className={classes.Heading}>{this.props.forEdit ? 'Edit Question ' + (this.props.pos + 1) : 'Add New Question'}</h4>
                {this.props.showContentLoader === true
                    ? <div className={classes.LoaderContainer}>
                        <ShowLoader isLoading={true} transparentBg={true} />
                    </div>
                    : <div> <img src={CloseIcon} alt={'Hide add new question form'} className={classes.CloseIcon}
                        onClick={this.props.forEdit ? () => this.props.hideEditForm(this.props.pos) : this.props.hideForm} />

                        <p className={classes.SubHeading}>Question Details</p>

                        <div className={classes.HorizontalInputs}>
                            <div className={classes.LevelInput}>
                                {this.inputField('difficultyLevel')}
                            </div>
                            <div className={classes.ScoreInput}>
                                {this.inputField('maxScore')}
                            </div>
                            <div className={classes.CorrectAnswersInput}>
                                {this.inputField('numberOfCorrectAnswers')}
                            </div>
                        </div>

                        <p className={classes.SubHeading}>Question Description</p>

                        <div className={classes.DescriptionInput}>
                            {this.inputField('questionDescription')}
                        </div>

                        <p className={classes.SubHeading}>Question Options</p>

                        <div className={classes.OptionsContainer}>
                            {renderOptionsList}

                            {
                                this.state.showError
                                    ? <p className={classes.ErrorMessage}>{this.state.errorMessage}</p>
                                    : null
                            }
                            <div className={classes.AddNewOptionDiv} onClick={this.onAddNewOptionClicked}>
                                <img src={AddIcon} alt="Add New Quiz Option" />

                                <p>Add a new option</p>
                            </div>
                        </div>

                        {
                            this.state.showConfirmationDialog
                                ? <ConfirmationDialog
                                    fixedPosition={true}
                                    showLoading={this.state.showDialogLoader}
                                    show={this.state.showConfirmationDialog}
                                    message={this.state.confirmationDialogMessage}
                                    secondaryButtonLabel={this.state.confirmationSecondaryButtonLabel}
                                    secondaryButtonClick={this.onConfirmationSecondaryButtonClick}
                                    primaryButtonLabel={this.state.confirmationPrimaryButtonLabel}
                                    primaryButtonClicked={this.onConfirmationPrimaryButtonClicked} />
                                : null
                        }

                        <div className={classes.SubmitButton}>
                            <Button
                                styleclass="NonMobileOnly"
                                label={this.props.forEdit ? "UPDATE QUESTION" : "ADD QUESTION"}
                                fontSize="0.8em"
                                padding="1em 3.5em"
                                clicked={this.onFormButtonClicked}
                            />
                            <Button
                                width="6em"
                                styleclass="MobileOnly"
                                label={this.props.forEdit ? "UPDATE QUESTION" : "ADD QUESTION"}
                                fontSize="0.625em"
                                padding="1em 3em"
                                margin="0px"
                                clicked={this.onFormButtonClicked}
                            />
                        </div>
                    </div>
                }

            </div>
        );
    }
}

export default QuizQuestionForm;